const facetParse = () => {

	function isset(obj) {
        return 'undefined' !== typeof obj;
    }

	if(typeof FWP !== "undefined") {
		FWP.parse_facets = function() {
			FWP.facets = {};

			jQuery('.facetwp-facet').each(function() {

				let skip = false;

				if(jQuery(window).width() < 960) {
					if (jQuery(this).parent().hasClass('c-filter-sidebar__filter') || jQuery(this).parent().hasClass('c-quicknav__subfilter--facet') || jQuery(this).parent().hasClass('--search')) {
						skip = true;
					}
				}
				
				if(!skip) {
					var $this = jQuery(this);
					var facet_name = $this.attr('data-name');
					var facet_type = $this.attr('data-type');

					// Store the facet type
					FWP.facet_type[facet_name] = facet_type;

					// Plugin hook
					FWP.hooks.doAction('facetwp/refresh/' + facet_type, $this, facet_name);

					// Support custom loader
					var do_loader = true;
					if (FWP.loaded) {
						if (FWP.soft_refresh || isset(FWP.frozen_facets[facet_name])) {
							do_loader = false;
						}
					}

					if (do_loader) {
						FWP.loading_handler({
							'element': $this,
							'facet_name': facet_name,
							'facet_type': facet_type
						});
					}
				}
			});

			// Add pagination to the URL hash
			if (1 < FWP.paged) {
				FWP.facets['paged'] = FWP.paged;
			}

			// Add "per page" to the URL hash
			if (FWP.extras.per_page && 'default' !== FWP.extras.per_page) {
				FWP.facets['per_page'] = FWP.extras.per_page;
			}

			// Add sorting to the URL hash
			if (FWP.extras.sort && 'default' !== FWP.extras.sort) {
				FWP.facets['sort'] = FWP.extras.sort;
			}
		}

	}

};

export default facetParse;